<template>
  <tab-page-template
    component-name="TradeContractList">
    <template #toolbar-items>
      <v-toolbar-title class="with-divider">
        取引実績管理
      </v-toolbar-title>
    </template>

    <template #tab-items>
      <v-tab :to="{name: alterRouteName('./tradeContracts')}">取引契約一覧</v-tab>
      <v-tab :to="{name: alterRouteName('./dataImplementations')}">データ実装一覧</v-tab>
    </template>
    <template #after-tabs>
      <router-view>
      </router-view>
    </template>
  </tab-page-template>
</template>

<script>
import PathInfoMixin from "@/router/PathInfoMixin";
import IoablePageMixin from "@/router/IoablePageMixin";
import TabPageTemplate from "@/components/templates/TabPageTemplate.vue";

export default {
  name: 'TradeResultList',
  components: {
    TabPageTemplate,
  },
  mixins: [
    PathInfoMixin,
    IoablePageMixin
  ],
}
</script>
